import { render } from "./DashboardCompetitiveTrends.vue?vue&type=template&id=7529326f"
import script from "./DashboardCompetitiveTrends.vue?vue&type=script&lang=js"
export * from "./DashboardCompetitiveTrends.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__